// ds-guard-ignore: vi phạm có sẵn trước khi chuyển từ components (C3)
import styled from 'styled-components'

interface UserMenuStyledProps {
  $themedark?: boolean
  $collapsemenu?: boolean
}

export const UserMenuStyled = styled.div<UserMenuStyledProps>`
  .ant-menu-inline,
  .ant-menu-vertical,
  .ant-menu {
    border-inline-end: none !important;
  }

  .ant-menu-item-selected,
  .ant-menu-submenu-selected > .ant-menu-submenu-title {
    font-weight: 500 !important;
  }

  .ant-menu-submenu-title {
    position: relative;
  }

  .sider-menu-hover-trigger {
    display: inline-flex;
    align-items: center;
    width: 100%;
    height: 100%;

    /* Mở rộng vùng hover phủ kín cả hàng của submenu để khi rê chuột vào bất cứ đâu trên hàng cũng kích hoạt popup bên phải */
    &::before {
      content: '';
      position: absolute;
      inset: 0;
      z-index: 1;
    }
  }

  /* Tùy chỉnh thanh cuộn cho nhỏ lại */
  &::-webkit-scrollbar,
  .side-bar-wrapper::-webkit-scrollbar,
  .ant-menu::-webkit-scrollbar {
    width: 1px;
    height: 1px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: var(--vbdt-color-border-default);
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: var(--vbdt-color-border-strong);
  }
`
